/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Position of creator
 */
export enum Position {
    SOLO = 'Solo',
    AGENCY = 'Agency',
}
